/**
 * Trigger an event.
 *
 * @param {object} vm - VueComponent.
 * @param {string} eventName - Nameof the emitted events.
 * @param {object} option - Custom options.
 * @return {object} - Event.
 */
export const eventEmit = (vm, eventName = "", option = {}) =>
  vm.$emit(eventName, option);



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-share-buttons/src/helpers/event.js
// module id = null
// module chunks = 